import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { toDateString } from "../../utilities/dateUtilities";
import stringHelpers from "../../utilities/stringHelpers";

export const AttachmentsDisplay = ({ attachments, onEditClick, onDeleteClick, canUpdate, viewLayout, type }) => {
    const [carouselOpen, setCarouselOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const images = attachments.filter(a => a.isImage);
    const filtered = type === 'images' ? images
        : type === 'documents' ? attachments.filter(a => !a.isImage)
        : attachments;
    const emptyMessage = type === 'images' ? 'No images found' : 'No documents found';

    const openCarousel = (index) => {
        setCurrentIndex(index);
        setCarouselOpen(true);
    };

    const goToPrev = () => setCurrentIndex(i => (i - 1 + images.length) % images.length);
    const goToNext = () => setCurrentIndex(i => (i + 1) % images.length);

    useEffect(() => {
        if (!carouselOpen) return;
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowLeft') goToPrev();
            if (e.key === 'ArrowRight') goToNext();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [carouselOpen, currentIndex]);

    const renderFileIcon = (contentType) => {
        switch (contentType) {
            case "application/pdf": return "fa-file-pdf";
            case "application/word.doc": return "fa-file-word";
            default: return "fa-file-alt";
        }
    };

    const renderActions = (attachment) => {
        return (
            <div className='d-flex'>
                <a href={ attachment.url } target='_blank' className="btn btn-none p-0 m-0"><i className='fas fa-download'></i></a>
                {
                    canUpdate && <div className="flex-shrink-0 ml-2">
                        { onEditClick && <button onClick={ () => onEditClick(attachment) } className="btn btn-none p-0 m-0"><i className="fas fa-edit"></i></button> }
                        <button onClick={ () => onDeleteClick(attachment.id) } className="btn btn-none p-0 m-0 ml-1"><i className="fas fa-trash-alt"></i></button>
                    </div>
                }
            </div>
        )
    };

    const renderGridCard = (attachment) => (
        <div key={ attachment.id } className="card rounded attachment-card-grid">
            <div className="attachment-card-grid-media">
                {
                    attachment.isImage
                        ? <img className="w-100 h-100 attachment-card-grid-img cursor-pointer" src={ attachment.url } onClick={ () => openCarousel(images.indexOf(attachment)) } />
                        : <div className="d-flex justify-content-center align-items-center w-100 h-100">
                            <i className={ `far fa-6x ${ renderFileIcon(attachment.contentType) }` }></i>
                        </div>
                }
            </div>
            <div className="card-body px-3">
                <div className="d-flex justify-content-between">
                    {
                        attachment.isImage
                            ? <h6 className="mb-0 attachment-card-grid-filename text-truncate cursor-pointer" title={ attachment.filename } onClick={ () => openCarousel(images.indexOf(attachment)) }>{ attachment.filename }</h6>
                            : <a href={ attachment.url } target="_blank" className="attachment-card-grid-filename"><h6 className="mb-0 text-truncate" title={ attachment.filename }>{ attachment.filename }</h6></a>
                    }
                    { renderActions(attachment) }
                </div>
                <div className="mt-2">
                    <div className="d-flex align-items-center">
                        <label className="m-0">Date:&nbsp;</label>
                        <small className="m-0">{ toDateString(attachment.timestamp) }</small>
                    </div>
                    {
                        !stringHelpers.isNullOrEmpty(attachment.validFrom) && !stringHelpers.isNullOrEmpty(attachment.validTo) && <div className="d-flex align-items-center mt-1">
                            <label className="m-0">Validity:&nbsp;</label>

                            <small className="m-0">
                                { toDateString(attachment.validFrom) }&nbsp;&nbsp;<i className="fas fa-arrow-right"></i>&nbsp;&nbsp;{ toDateString(attachment.validTo) }
                            </small>

                        </div>
                    }
                </div>
            </div>
        </div>
    );

    const renderListCard = (attachment) => (
        <div key={ attachment.id } className="card rounded mb-2 d-flex flex-row align-items-center w-100">
            <div className="d-flex align-items-center pl-2 py-1 attachment-card-list-thumbnail">
                {
                    attachment.isImage
                        ? <img className="w-100 h-100 attachment-card-list-thumbnail-img cursor-pointer" src={ attachment.url } onClick={ () => openCarousel(images.indexOf(attachment)) } />
                        : <div className="d-flex justify-content-center align-items-center w-100 h-100">
                            <i className={ `far fa-2x ${ renderFileIcon(attachment.contentType) }` }></i>
                        </div>
                }
            </div>
            <div className="card-body px-3 py-2 d-flex justify-content-between align-items-center">
                <div className="row w-100 align-items-center">
                    <div className="col-2" style={{ minWidth: 0 }}>
                        {
                            attachment.isImage
                                ? <h6 className="mb-0 cursor-pointer text-truncate" title={ attachment.filename } onClick={ () => openCarousel(images.indexOf(attachment)) }>{ attachment.filename }</h6>
                                : <a href={ attachment.url } target="_blank" className="d-block text-truncate"><h6 className="mb-0 text-truncate" title={ attachment.filename }>{ attachment.filename }</h6></a>
                        }
                    </div>
                    <div className="col-1 d-flex align-items-center">
                        <small className="text-muted m-0 mr-1">Date:</small>
                        <small className="m-0">{ toDateString(attachment.timestamp) }</small>
                    </div>
                    {
                        !stringHelpers.isNullOrEmpty(attachment.validFrom) && !stringHelpers.isNullOrEmpty(attachment.validTo) &&
                        <div className="col-2 d-flex align-items-center">
                            <small className="text-muted m-0 mr-1">Validity:</small>
                            <small className="m-0" style={{ whiteSpace: 'nowrap' }}>{ toDateString(attachment.validFrom) }&nbsp;<i className="fas fa-arrow-right"></i>&nbsp;{ toDateString(attachment.validTo) }</small>
                        </div>
                    }
                </div>
                <div className="flex-shrink-0">{ renderActions(attachment) }</div>
            </div>
        </div>
    );

    if (filtered.length === 0) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center py-5 text-muted">
                <i className="far fa-folder-open fa-2x mb-3"></i>
                <p className="m-0">{ emptyMessage }</p>
            </div>
        );
    }

    return (
        <>
            <div className={ viewLayout === "list" ? "" : "attachment-grid-container" }>
                { filtered.map(attachment => viewLayout === "list" ? renderListCard(attachment) : renderGridCard(attachment)) }
            </div>

            <Modal show={ carouselOpen } onHide={ () => setCarouselOpen(false) } centered size="lg">
                { images.length > 0 && (
                    <Modal.Header className="bg-white d-flex justify-content-between p-2">
                        <p className="m-0 text-truncate mr-2" style={{ flex: 1, minWidth: 0 }} title={ images[currentIndex]?.filename }>{ images[currentIndex]?.filename }</p>
                        <p className="m-0 flex-shrink-0">{ toDateString(images[currentIndex]?.timestamp) }</p>
                    </Modal.Header>
                ) }
                <Modal.Body className="p-0">
                    <div className="carousel slide">
                        <div className="carousel-inner">
                            { images.map((image, i) => (
                                <div key={ image.id } className={ `carousel-item${ i === currentIndex ? ' active' : '' }` }>
                                    <img src={ image.url } alt={ image.filename } className="d-block w-100 attachment-carousel-img" />
                                </div>
                            )) }
                        </div>
                        { images.length > 1 && (
                            <>
                                <button className="carousel-control-prev gallery-chevron" onClick={ goToPrev }>
                                    <i className="fas fa-chevron-left" aria-hidden="true" />
                                </button>
                                <button className="carousel-control-next gallery-chevron" onClick={ goToNext }>
                                    <i className="fas fa-chevron-right" aria-hidden="true" />
                                </button>
                            </>
                        ) }
                    </div>
                </Modal.Body>

                <Modal.Footer className="py-1 px-3 d-flex align-items-center">
                    { images.length > 1 && <span className="small">{ currentIndex + 1 } / { images.length }</span> }
                    <button className="btn btn-secondary btn-sm" onClick={ () => setCarouselOpen(false) }>Close</button>
                </Modal.Footer>

            </Modal>
        </>
    );
};
